module.exports = __webpack_public_path__ + "assets/adpoly-accommodation-bulk-upload-template.8d77941f.xlsx";